import React from 'react';
import { hydrate } from 'react-dom';
import { getLogger } from '@cian/logger/browser';
import { ErrorLogComponent } from '@cian/error-log-component';
import { IHeaderV1Schema } from '../../../shared/repositories/header/entities/response/HeaderV1Schema';

export const initializeUserMenu = async (headerData: IHeaderV1Schema, isProfessionalSearchPromoEnabled: boolean) => {
  const userMenuPanelElement = document.getElementById('header-user-menu');
  const logger = getLogger();

  if (headerData.isAuthenticated && userMenuPanelElement) {
    const { UserMenu } = await import('../../../shared/components/UserMenu');

    hydrate(
      <ErrorLogComponent logger={logger}>
        <UserMenu headerData={headerData} isProfessionalSearchPromoEnabled={isProfessionalSearchPromoEnabled} />
      </ErrorLogComponent>,
      userMenuPanelElement,
    );
  }
};
